import { EboObject } from '../../base-classes/ebo-object';
import { Terminal } from '../terminal/terminal';
import { Plot } from './plot';

export class PlotTerminal extends EboObject {
  terminalId: string;
  terminal: Terminal;
  propertyId: string;
  property: Plot;

  constructor(jsonData?: Partial<PlotTerminal>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.terminal) {
        this.terminal = new Terminal(jsonData.terminal);
      }
      if (jsonData.property) {
        this.property = new Plot(jsonData.property);
      }
    }
  }
}
